import type { RouteObject } from 'react-router';

import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router';

import { DocumentTitle } from 'src/routes/components';

import { getConfig } from 'src/global-config';

import { SplashScreen } from 'src/components/loading-screen/splash-screen';

import { authRoutes } from './auth';
import { getJobsRoutes } from './jobs';
import { getErrorRoutes } from './error';
import { getBillingRoutes } from './billing';
import { playgroundRoutes } from './playground';
import { getDashboardRoutes } from './dashboard';
import { getCandidateRoutes } from './candidates';
import { getCreateJobRoutes } from './create-job';
import { getEventsTrialRoutes } from './events-trial';
import { getGettingStartedRoutes } from './getting-started';
import { getOrganizationSettingRoutes } from './organization-setting';
import { getCandidateEvidenceViewRoutes } from './candidate-evidence-view';
// ----------------------------------------------------------------------

const Page404 = lazy(() => import('src/pages/error/404'));

export function getRoutesSection() {
  const CONFIG = getConfig();

  const routesSection: RouteObject[] = [
    {
      path: '/',
      element: <Navigate to={CONFIG.auth.redirectPath} replace />,
    },

    // Auth
    ...authRoutes,

    // Dashboard
    ...getDashboardRoutes(),
    // Getting Started
    ...getGettingStartedRoutes(),
    // Jobs
    ...getJobsRoutes(),
    // Organization Settings
    ...getOrganizationSettingRoutes(),
    // Candidates
    ...getCandidateRoutes(),
    // Create Job
    ...getCreateJobRoutes(),
    // Candidate Evidence View
    ...getCandidateEvidenceViewRoutes(),
    // Billing callbacks
    ...getBillingRoutes(),
    // Events trial landing (public, no auth guard)
    ...getEventsTrialRoutes(),
    // Playground
    ...playgroundRoutes,
    // Error pages
    ...getErrorRoutes(),
    // No match
    {
      path: '*',
      element: (
        <Suspense fallback={<SplashScreen />}>
          <>
            <DocumentTitle titleOverride="Page not found" />
            <Page404 />
          </>
        </Suspense>
      ),
    },
  ];

  return routesSection;
}
